/** SAIT-135: одна точка монтирования в Footer; переход по сайту закрывает окно и ожидание. */
import { watch, onBeforeUnmount } from 'ui.vue3';
import { vplSiteStore } from '../../store/vplstore';
import { newsletterState, closeNewsletter } from './newsletter-state';

const template = `
    <component v-if="newsletterState.open && newsletterState.dialog" :is="newsletterState.dialog"
        :source="newsletterState.source" :trigger="newsletterState.trigger" @close="closeNewsletter" />
`;
export const NewsletterDialogHost = {
    setup() {
        const store = vplSiteStore();
        watch(() => store.url, closeNewsletter);
        onBeforeUnmount(closeNewsletter);
        return { newsletterState, closeNewsletter };
    },
    template,
};
